module.exports = __webpack_public_path__ + "static/img/b03.8dbbc10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/b03.png
// module id = wT14
// module chunks = 0